import { breakpoints, Modal, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

const IMAGE_HEIGHT = '65vh';

export const Wrapper = styled.div`
  overflow: hidden;
  height: ${IMAGE_HEIGHT};
  position: relative;
  user-select: none;
`;

export const CarouselTrack = styled.div`
  display: flex;
  height: 100%;
  transition: transform 0.35s ease-in-out;
  will-change: transform;

  &[data-zoomed='true'] {
    transition: none;
  }
`;

export const Slide = styled.div`
  min-width: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const ZoomContainer = styled.div`
  --sidePad: 4rem;
  padding: 0 var(--sidePad);
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: zoom-in;

  // Padding effect on edges when zoomed in
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: var(--sidePad);
    background: ${theme.color.background.primary};
    z-index: 1;
    pointer-events: none;
  }
  &::before {
    left: 0;
  }
  &::after {
    right: 0;
  }

  &[data-zoomed='true'] {
    cursor: zoom-out;
  }
`;

export const Image = styled.img`
  max-width: 100%;
  height: ${IMAGE_HEIGHT};
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.2s ease;
`;

export const ThumbsWrapper = styled.div`
  width: 100%;
  padding: 1.25rem;
`;

export const VideoSizeContainer = styled.div`
  flex-basis: 100vh;
`;

export const PlayerWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  width: 100%;
  height: 0;
  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    @media (min-width: ${breakpoints.md}) {
      background: ${theme.color.background.disabled};
    }
  }
`;

export const GalleryModal = styled(Modal)`
  position: absolute;
  height: 100%;
`;
